import { BiaxCartItem } from './types';

export function getTermTranslationKey(code: string) {
    const year = code.length >= 4 ? code.substring(0, 4) : '';
    const translateInput = code.length >= 6 && code.substring(code.length - 2) === '10' ? 'spring' : 'autumn';
    return [`cart:${translateInput}`, year];
}

export function openCart() {
    const item = document.getElementById('cart-content');
    if (item && 'toggleModalOpen' in item) {
        // @ts-expect-error we know the item has the method toggleModalOpen
        item.toggleModalOpen();
    } else {
        console.error('Could not find the modal with id = "cart-content"');
    }
}

export function isArrangementInCart(id: string, cartItems: BiaxCartItem[]): boolean {
    return cartItems.some(({ bannerId }) => bannerId === id);
}

export const mapCampusToCampusCode: { [key: string]: string[] } = {
    Oslo: ['O', 'A', 'S', 'Æ', 'Y', 'E', 'W'],
    Bergen: ['B'],
    Stavanger: ['R'],
    Trondheim: ['T'],
    Nettstudier: ['F'],
};

export const mapCampusCodeToCampus: { [key: string]: string } = {
    O: 'Oslo',
    A: 'Oslo',
    S: 'Oslo',
    Æ: 'Oslo',
    Y: 'Oslo',
    E: 'Oslo',
    W: 'Oslo',
    B: 'Bergen',
    R: 'Stavanger',
    T: 'Trondheim',
    F: 'Nettstudier',
};

export function addVoiceTextElementToCart(text: string) {
    const cartitems = document.querySelector('#cartitems');

    if (cartitems) {
        const divElement = document.createElement('div');
        divElement.textContent = text;
        divElement.classList.add('voiceText', 'infotext', 'sr-only');
        divElement.id = 'voiceText';
        divElement.role = 'status';
        cartitems.append(divElement);
    }
}

export function hasProperty(obj: unknown, key: string): obj is { [key: string]: unknown } {
    return typeof obj === 'object' && obj !== null && key in obj;
}
